// Keeps phone and name boxes clean as the shopper types (the server checks
// them again). Bound once via event delegation, so it works on every page
// and after Turbolinks visits.
//
//  * Phone: digits only, at most 10.
//  * Names (first / last / full / billing / delivery name): letters, spaces,
//    hyphens, apostrophes and full stops only.

const NAME_FIELD = /\[?(first_name|last_name|full_name|billing_name|delivery_name)\]?$/
const NOT_NAME_CHARS = /[^\p{L} .'’-]/gu

function filterFor(input) {
  if (input.type === 'tel') return (value) => value.replace(/\D/g, '').slice(0, 10)
  if (input.type === 'text' && NAME_FIELD.test(input.name || '')) return (value) => value.replace(NOT_NAME_CHARS, '')
  return null
}

document.addEventListener('input', function (event) {
  const input = event.target
  if (!input || input.tagName !== 'INPUT') return

  const filter = filterFor(input)
  if (!filter) return

  const cleaned = filter(input.value)
  if (cleaned !== input.value) input.value = cleaned
})
